import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { allowedPartners, LOGOS, PartnerKey } from '../RefSignUp.constants';

export const useRefSignUpPartner = () => {
  const [searchParams] = useSearchParams();

  const partner = useMemo(() => {
    const allParams = Array.from(searchParams.entries()).flat();
    return (
      allParams
        .map((param) => findPartnerInText(param))
        .find((p) => p !== null) || null
    );
  }, [searchParams]);

  const partnerData = partner ? LOGOS[partner] : null;

  return {
    logo: partnerData?.logo || null,
    label: partnerData?.label || null,
  };
};

const findPartnerInText = (text: string): PartnerKey | null => {
  const lowerText = text.toLowerCase();
  const foundPartner = allowedPartners.find((partner) =>
    lowerText.includes(partner),
  );
  return foundPartner || null;
};
